import { useState, useEffect } from "react";
import MobileVertification from "../../PopModal/MobileVertification";
import Footer from "../../Components/General/Client/Footer";
import Header from "../../Components/General/Client/Header";
import apiService from "../../Services/apiService";
import Maps from "../../Components/Maps";

const BranchesOnMap = () => {
  const [isShowFilter, setisShowFilter] = useState(true);
  const [isColorArea, setisColorArea] = useState(false);
  const [hasUserClient, setHasUserClient] = useState(false);
  const [branchesData, setbranchesData] = useState<any[]>([]);
  useEffect(() => {
    setHasUserClient(!!localStorage.getItem("user-client"));
    console.log("---------");
    console.log(branchesData);
  }, []);
  return (
    <>
      <>
        <main className="w-full h-screen bg-surface">
          <div className="flex flex-col w-full h-full relative overflow-hidden">
            {/* Map Container Placeholder */}
            <Maps
              shops={branchesData}
              isColorArea={isColorArea}
              setisColorArea={setisColorArea}
            />
            {/* Decorative Overlay for Depth */}
            <div className="absolute inset-0 z-0 bg-gradient-to-t from-primary/30 to-transparent pointer-events-none" />
            {/* Top Floating Filter Bar (Desktop) / Collapsible (Mobile) */}
            {isShowFilter && <Header _setbranchesData={setbranchesData} />}
            {/* Interactive Map Markers (Mocked as Floating Elements over Map) */}
            <div className="absolute inset-0 z-10 pointer-events-none"></div>
            {/* Side Controls (Color by Region) */}
            <div className="absolute left-4 bottom-24 md:bottom-12 md:left-8 z-20">
              <div className="bg-surface/95 backdrop-blur-xl rounded-xl shadow-lg p-2 flex flex-col gap-2">
                <button
                  className="w-10 h-10 rounded-lg flex items-center justify-center bg-primary text-on-primary hover:bg-primary/90 transition-colors group relative pointer-events-auto"
                  id="filter-toggle"
                >
                  <span>{branchesData.length}</span>
                </button>
                <button
                  onClick={() =>
                    isShowFilter
                      ? setisShowFilter(false)
                      : setisShowFilter(true)
                  }
                  className="w-10 h-10 rounded-lg flex items-center justify-center bg-primary text-on-primary hover:bg-primary/90 transition-colors group relative pointer-events-auto"
                  id="filter-toggle"
                >
                  <span className="material-symbols-outlined">filter_list</span>
                  <div className="absolute right-full mr-2 bg-inverse-surface text-inverse-on-surface text-label-sm font-label-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap transition-opacity">
                    إظهار/إخفاء الفلاتر
                  </div>
                </button>
                <button
                  onClick={() =>
                    isColorArea ? setisColorArea(false) : setisColorArea(true)
                  }
                  className="w-10 h-10 rounded-lg flex items-center justify-center bg-primary text-on-primary hover:bg-primary/90 transition-colors group relative pointer-events-auto"
                  id="filter-toggle"
                >
                  <span className="material-symbols-outlined">color_lens</span>
                  <div className="absolute right-full mr-2 bg-inverse-surface text-inverse-on-surface text-label-sm font-label-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap transition-opacity">
                    تلوين عبر المناطق
                  </div>
                </button>

                {/* <button className="w-10 h-10 rounded-lg flex items-center justify-center bg-surface-container-low text-on-surface-variant hover:bg-surface-container transition-colors group relative">
            <span className="material-symbols-outlined">my_location</span>
            <div className="absolute right-full mr-2 bg-inverse-surface text-inverse-on-surface text-label-sm font-label-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap transition-opacity">
              موقعي الحالي
            </div>
          </button>
          <div className="w-8 mx-auto h-px bg-outline-variant/30 my-1" />
          <button className="w-10 h-10 rounded-lg flex items-center justify-center bg-surface-container-low text-on-surface-variant hover:bg-surface-container transition-colors">
            <span className="material-symbols-outlined">add</span>
          </button>
          <button className="w-10 h-10 rounded-lg flex items-center justify-center bg-surface-container-low text-on-surface-variant hover:bg-surface-container transition-colors">
            <span className="material-symbols-outlined">remove</span>
          </button> */}
              </div>
            </div>
            {/* Bottom Floating "Show on Map" Button (Mobile Focused) */}
            <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-20 md:hidden w-[90%] max-w-sm">
              <button className="w-full bg-primary text-on-primary font-headline-md text-[18px] py-4 rounded-xl shadow-2xl flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors">
                <span className="material-symbols-outlined">map</span>
                عرض عبر الخريطة
              </button>
            </div>
            {/* Floating Chat Button */}
            <button className="absolute right-4 bottom-24 md:right-8 md:bottom-12 z-30 w-14 h-14 bg-primary text-on-primary rounded-full shadow-xl flex items-center justify-center hover:scale-105 transition-transform group">
              <span className="material-symbols-outlined absolute transition-transform group-hover:scale-0">
                chat
              </span>
              <span className="material-symbols-outlined absolute scale-0 transition-transform group-hover:scale-100">
                support_agent
              </span>
              {/* Notification Dot */}
              <span className="absolute top-0 right-0 w-3.5 h-3.5 bg-error border-2 border-surface rounded-full" />
            </button>
            {/* Subtle Footer */}
            <Footer />
          </div>
        </main>
        {/* OTP Verification Overlay */}
        {!hasUserClient && (
          <MobileVertification setHasUserClient={setHasUserClient} />
        )}
      </>
    </>
  );
};
export default BranchesOnMap;
